import {Component, OnInit} from '@angular/core';
import {ContactService, CustomerService, Trustee, TrusteeService, UserAuthService} from '@lifeislife/lifeislife-domain';
import {combineLatest, Observable, of} from 'rxjs';
import {map, publishReplay, refCount, switchMap, tap} from 'rxjs/operators';
import {CustomerContextService} from '../../service/customer-context-service';
import {Router} from '@angular/router';

@Component({
  selector: 'cf-logged-user-menu',
  templateUrl: './logged-user-menu.component.html',
  styleUrls: ['./logged-user-menu.component.scss'],
})
export class LoggedUserMenuComponent implements OnInit {

  menuVisible$: Observable<boolean>;
  // Whether to show customer name or contact name;
  customerVisible$: Observable<boolean>;
  contactVisible$: Observable<boolean>;

  customerName$: Observable<string>;
  contactName$: Observable<string>;

  hasMoreCustomer$: Observable<boolean>;
  contextTrustee$: Observable<Trustee>;

  constructor(
    private userAuthService: UserAuthService,
    private customerContextService: CustomerContextService,
    private customerService: CustomerService,
    private contactService: ContactService,
    private trusteeService: TrusteeService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    const customerRef$ = this.customerContextService.activeCustomerContact$.pipe(
      map(c => c == null ? null : c.customerRef),
      publishReplay(1), refCount(),
    );
    const userLoggedIn$ = this.userAuthService.state$.pipe(
      map(s => s.status === 'authenticated'),
      publishReplay(1), refCount(),
    );
    this.menuVisible$ = combineLatest([customerRef$, userLoggedIn$]).pipe(
      map(r => r[1]),
      publishReplay(1), refCount(),
    );
    this.customerName$ = customerRef$.pipe(
      switchMap(ref => ref == null ? of(null) : this.customerService.getCustomerLabel$(ref)),
      publishReplay(1), refCount(),
    );
    this.customerVisible$ = this.customerName$.pipe(map(n => n != null), publishReplay(1), refCount());
    this.contactVisible$ = this.customerName$.pipe(map(n => n == null), publishReplay(1), refCount());
    this.contextTrustee$ = customerRef$.pipe(
      switchMap(ref => ref == null ? of(null) : this.customerService.getCustomer$(ref)),
      switchMap(c => c == null ? of(null) : this.trusteeService.getTrustee$(c.trusteeRef)),
      publishReplay(1), refCount(),
    );
    this.contactName$ = this.userAuthService.state$.pipe(
      map(s => s.contactRef),
      switchMap(ref => ref == null ? of(null) : this.contactService.getContact$(ref)),
      map(c => c == null ? null : this.contactService.getContactName(c, false)),
      publishReplay(1), refCount(),
    );

    this.hasMoreCustomer$ = this.customerContextService.availableCustomerContacts$.pipe(
      map(a => a.length > 1),
      publishReplay(1), refCount(),
    );
  }

  onChangeCustomerClick() {
    this.customerContextService.selectCustomerContactRef(null);
  }

  onLogoutClick() {
    this.userAuthService.deauthenticate(undefined, true);
  }
}
